export default __webpack_public_path__ + "static/media/img/solaire.webp";